import { render } from "./Prediction.vue?vue&type=template&id=74325f4e&scoped=true"
import script from "./Prediction.vue?vue&type=script&lang=js"
export * from "./Prediction.vue?vue&type=script&lang=js"

import "./Prediction.vue?vue&type=style&index=0&id=74325f4e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-74325f4e"

export default script